import axios from "../../axios";

const state = {};

const actions = {
  /**
   * @param commit
   * @param payload
   * @returns {Promise<void>}
   */
  // eslint-disable-next-line no-unused-vars
  async textToSpeech({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("openai/speech", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  async translations({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("openai/translations", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  async createAnswer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("openai/create-answer", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
